import React, { useMemo, useState } from "react";

const CreateTagSectionForm = ({
  sectionTitle,
  setSectionTitle,
  sectionDesc,
  setSectionDesc,
  sectionMode,
  setSectionMode,
  tags,
  selectedTagIds,
  setSelectedTagIds,
  onSubmit,
}) => {
  const [search, setSearch] = useState("");
  const visibleTags = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return tags;
    return tags.filter((tag) => `${tag.name || ""} ${tag.server_name || ""}`.toLowerCase().includes(query));
  }, [search, tags]);

  const toggleTag = (id) => {
    setSelectedTagIds((current) => current.includes(id) ? current.filter((tagId) => tagId !== id) : [...current, id]);
  };

  return (
    <div className="pb-card pb-create-card pb-create-card--section">
      <h2>Create Tag Section</h2>
      <form onSubmit={onSubmit}>
        <label className="pb-label">Title</label>
        <input
          className="pb-input"
          value={sectionTitle}
          onChange={(e) => setSectionTitle(e.target.value)}
          placeholder="e.g. Reactor Instruments"
          required
        />

        <label className="pb-label">Mode</label>
        <select
          className="pb-select"
          value={sectionMode}
          onChange={(e) => setSectionMode(e.target.value)}
        >
          <option value="analog">Analog</option>
          <option value="digital">Digital</option>
          <option value="io">IO (Analog Input)</option>
        </select>

        <label className="pb-label">Description (optional)</label>
        <textarea
          className="pb-textarea"
          value={sectionDesc}
          onChange={(e) => setSectionDesc(e.target.value)}
          placeholder="Optional"
        />

        <div className="pb-inline-picker">
          <div className="pb-inline-picker-heading"><div><strong>Add tags to this section</strong><small>Optional · {selectedTagIds.length} selected</small></div>{selectedTagIds.length > 0 && <button type="button" className="pb-clear-btn" onClick={() => setSelectedTagIds([])}>Clear</button>}</div>
          <input className="pb-input pb-picker-search" type="search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search tags by any part of the name…" />
          <div className="pb-picker-list">
            {visibleTags.map((tag) => <label className={`pb-picker-option ${selectedTagIds.includes(tag.id) ? "is-selected" : ""}`} key={tag.id}>
              <input type="checkbox" checked={selectedTagIds.includes(tag.id)} onChange={() => toggleTag(tag.id)} />
              <span><strong>{tag.name}</strong>{tag.server_name && <small>{tag.server_name}</small>}</span>
            </label>)}
            {visibleTags.length === 0 && <div className="pb-picker-empty">No matching tags.</div>}
          </div>
        </div>

        <button className="pb-button" type="submit">
          Create Section
        </button>
      </form>
    </div>
  );
};

export default CreateTagSectionForm;
